module.exports = __webpack_public_path__ + "img/hr-pipe-t-right.889a52a9.png";